import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  FORM_BP,
  FORM_MG,
  FORM_MG_NO_SHOP,
  MODALITY_PAYMENT_CUOTA_FIJA,
  MODALITY_PAYMENT_FIN_MES,
  PENDIENTES_DE_DATOS,
  REQUEST_DATA,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_VIEW,
} from '@app/@core/constants/requests.constants';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';

@Component({
  selector: 'scf-request-data-card',
  templateUrl: './request-data-card.component.html',
  styleUrls: ['./request-data-card.component.scss'],
})
export class RequestDataCardComponent implements OnInit {
  @Input() public mode: string = 'new';
  @Input() public request: any = null;
  @Input() state: CommonDataDTO;
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public isFinishedLoading = new EventEmitter<any>();

  isLoading: boolean = false;
  showSelectAmount: boolean = false;
  showOtherAmount: boolean = false;

  amount: string = '';
  formattedAmount: string = '';

  public requestDataCardForm: FormGroup;

  expirationDaysList: CommonDataDTO[];
  modalityPaymentList: CommonDataDTO[];
  fixedFeeList: CommonDataDTO[];

  //Loading
  private isExpirationDaysLoading: boolean = false;
  private isFixedFeeLoading: boolean = false;
  private isModalityPaymentLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private requestStore: RequestsSaveSendStore,
    private combosStore: CombosStore,
    private customValidators: CustomValidatorsService
  ) {}

  ngOnInit(): void {
    this.requestDataCardForm = this.formBuilder.group({
      expirationDay: ['', Validators.required],
      modality: ['', Validators.required],
      amountCard: [''],
      otherAmountCard: [''],
    });

    this.isModalityPaymentLoading = true;
    this.combosStore.modalityPaymentList$.subscribe((valor: CommonDataDTO[]) => {
      this.modalityPaymentList = valor;
      this.isModalityPaymentLoading = false;
      this.changeLoadingState();
    });

    this.isExpirationDaysLoading = true;
    this.combosStore
      .loadExpirationDays(10)
      .then((expirationDays: CommonDataDTO[]) => {
        this.expirationDaysList = expirationDays;

        //first day by default(ESPSCFWMTS-5245)
        if (this.request?.expirationDay)
          this.requestDataCardForm.controls.expirationDay.setValue(this.request.expirationDay);
        else this.requestDataCardForm.controls.expirationDay.setValue(this.expirationDaysList[0].id);
      })
      .finally(() => {
        this.isExpirationDaysLoading = false;
        this.changeLoadingState();
      });

    //load combo
    this.isFixedFeeLoading = true;
    this.fixedFeeList = this.combosStore.fixedFeeList;
    //setear combo si solo hay un valor
    if (this.fixedFeeList.length === 1) {
      this.requestDataCardForm.controls.amountCard.setValue(this.fixedFeeList[0].id);
      this.onChangeAmount();
    }
    this.isFixedFeeLoading = false;
    this.changeLoadingState();

    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.requestDataCardForm, REQUEST_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.requestDataCardForm, REQUEST_DATA);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.requestDataCardForm, REQUEST_DATA);
    }

    this.requestDataCardForm.statusChanges.subscribe(() => {
      this.changeContinueStatus.emit({ form: <FormGroup>this.requestDataCardForm, id: REQUEST_DATA });
    });

    if (this.mode === REQUEST_MODE_VIEW) {
      if (this.state.id !== PENDIENTES_DE_DATOS) {
        this.requestDataCardForm.disable();
      }
      this.setValuesToForm();
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.setValuesToForm();
    }
  }

  onChangeModality() {
    if (this.requestDataCardForm.controls.modality.value === MODALITY_PAYMENT_FIN_MES) {
      this.showSelectAmount = false;
      this.showOtherAmount = false;
      this.requestDataCardForm.controls.amountCard.setValidators(null);
      this.requestDataCardForm.controls.amountCard.updateValueAndValidity();
      this.requestDataCardForm.controls.otherAmountCard.setValidators(null);
      this.requestDataCardForm.controls.otherAmountCard.updateValueAndValidity();
    } else {
      this.showSelectAmount = true;
      if (this.requestDataCardForm.controls.amountCard.value === 'Other') {
        this.showOtherAmount = true;
        this.requestDataCardForm.controls.otherAmountCard.setValidators([Validators.required]);
      }
      this.requestDataCardForm.controls.amountCard.setValidators([Validators.required]);
    }
  }

  onChangeAmount() {
    if (this.requestDataCardForm.controls.amountCard.value === 'Other') {
      this.showOtherAmount = true;
      this.requestDataCardForm.controls.otherAmountCard.setValidators([Validators.required]);
    } else {
      this.showOtherAmount = false;
      this.requestDataCardForm.controls.otherAmountCard.setValidators(null);
      this.requestDataCardForm.controls.otherAmountCard.updateValueAndValidity();
    }
  }

  numberOnly(event: any): boolean {
    return this.customValidators.numberOnly(event.which ? event.which : event.keyCode, this.amount);
  }

  getFormattedAmount() {
    this.formattedAmount = this.customValidators.transformAmount(this.amount);
    this.amount = this.formattedAmount;
  }

  setValuesToForm() {
    this.requestDataCardForm.controls.expirationDay.setValue(this.request.expirationDay);
    this.requestDataCardForm.controls.modality.setValue(this.request.modPaymentCard);
    this.onChangeModality();

    if (this.requestDataCardForm.controls.modality.value === MODALITY_PAYMENT_CUOTA_FIJA) {
      let amount: number = Number(this.request.amountCard.replace(',', '.'));
      if (amount == 20 || amount == 50 || amount == 90 || amount == 120) {
        this.requestDataCardForm.controls.amountCard.setValue(String(amount));
      } else {
        this.requestDataCardForm.controls.amountCard.setValue('Other');
        this.showOtherAmount = true;
        this.amount = this.request.amountCard;
        this.requestDataCardForm.controls.otherAmountCard.setValidators([Validators.required]);
      }
    }
  }

  private changeLoadingState() {
    if (!this.isModalityPaymentLoading && !this.isExpirationDaysLoading && !this.isFixedFeeLoading) {
      this.isFinishedLoading.emit({ formID: REQUEST_DATA, value: true });
    } else {
      this.isFinishedLoading.emit({ formID: REQUEST_DATA, value: false });
    }
  }
}
